export enum DataSourceCategories {
  development = 'Development',
  design = 'Design',
  project_management = 'Project Management',
  collaboration = 'Collaboration',
  calendar = 'Calendar',
  communication = 'Communication',
  crm = 'CRM',
  hris = 'HRIS',
}

export enum IntegrationType {
  data_source = 'data_source_destination',
  notification_destination = 'notification_destination',
}

export type Integration = {
  name: string;
  connected: boolean;
  path: string;
  description: string;
  logo: string;
  slug: string;
  categories?: Array<DataSourceCategories>;
  flag?: string;
  type?: IntegrationType;
  isCalendar?: boolean;
};
